// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"b1d15d78","386":"f0cda1b6","453":"db324977","726":"b5dfb218"}[chunkId] + ".chunk.js";
};